module.exports = __webpack_public_path__ + "img/트릭스터.0d58585e.png";